export const translations = {
  tr: {
    nav: {
      features: "Özellikler",
      pricing: "Fiyatlandırma",
      faq: "SSS",
      contact: "İletişim",
      blog: "Blog",
      demoLogin: "Panel Giriş",
      register: "Müşteri Ol",
    },
    hero: {
      overline: "B2B BAYI YÖNETİM SİSTEMİ",
      title: "Tekliften Siparişe,",
      titleHighlight: "Her Şey Tek Panelde.",
      subtitle: "B2B bayi yönetim yazılımı ile tekliflerinizi oluşturun, siparişlerinizi takip edin, bayi ağınızı yönetin. SMS, WhatsApp ve e-posta ile müşterilerinize anında ulaşın. Entegre tedarikçi sistemi ve ön muhasebe dahil.",
      cta: "Ücretsiz Başla",
      ctaSecondary: "Demo İncele",
      conversionRate: "Teklif → Sipariş",
    },
    stats: {
      dealers: "Aktif Bayi",
      orders: "Aylık Sipariş",
      quotes: "Teklif Gönderimi",
      satisfaction: "Müşteri Memnuniyeti",
    },
    features: {
      overline: "ÖZELLİKLER",
      title: "B2B İş Süreçlerinizi Tek Panelden Yönetin",
      subtitle: "Teklif yönetimi, sipariş takibi, bayi portalı, entegre tedarikçi sistemi ve ön muhasebe yazılımı. Tüm iş süreçleriniz tek bir platformda.",
      quoteManagement: "Teklif Yönetimi",
      quoteDesc: "TL, USD, EUR, GBP ile profesyonel teklifler oluşturun. SMS, WhatsApp ve e-posta ile anında müşterilerinize gönderin. Teklif görüntülenme takibi yapın.",
      orderManagement: "Sipariş Yönetimi",
      orderDesc: "Fabrika siparişlerinizi merkezi noktadan yönetin. Onaylanan teklifleri tek tıkla siparişe dönüştürün. Termin tarihi ve ödeme takibi.",
      dealerManagement: "Bayi & Şube Yönetimi",
      dealerDesc: "Bayi ağınızı ve şubelerinizi tek panelden yönetin. Bayi performans takibi, bağlantı sözleşmeleri ve toplu teklif gönderimi.",
      supplierIntegration: "Entegre Tedarikçi Sistemi",
      supplierDesc: "Entegre tedarikçilerden ürün ve fiyat bilgisi alın, doğrudan sipariş verin. Otomatik fiyat senkronizasyonu.",
      preAccounting: "Ön Muhasebe Yazılımı",
      preAccountingDesc: "Satış/alış faturaları, banka işlemleri, masraf kaydı ve stok takibi. Gelir-gider raporları ile finansal kontrolünüzü sağlayın.",
      analytics: "Detaylı Analiz & Raporlar",
      analyticsDesc: "Ciro, sipariş trendleri, bayi performansı ve dönüşüm oranlarını detaylı grafiklerle analiz edin. Veri odaklı kararlar alın.",
    },
    crm: {
      overline: "B2B CRM",
      title: "Sahada Güçlü, Masada Akıllı",
      subtitle: "Ziyaret planlama, pipeline yönetimi, müşteri haritası ve detaylı raporlarla satış sürecinizi optimize edin.",
      visits: "Ziyaret Takvimi",
      visitsDesc: "Saha ekibinizin ziyaretlerini planlayın ve takip edin.",
      pipeline: "Satış Pipeline",
      pipelineDesc: "Fırsatlarınızı ilgili, nitelikli, teklif ve pazarlık aşamalarında yönetin.",
      map: "Müşteri Haritası",
      mapDesc: "Müşterilerinizi harita üzerinde görüntüleyin ve rota planlayın.",
      reports: "CRM Raporları",
      reportsDesc: "Ziyaret, teklif ve sipariş trendlerinizi analiz edin.",
    },
    communication: {
      overline: "İLETİŞİM KANALLARI",
      title: "Tekliflerinizi Anında Gönderin",
      subtitle: "E-posta, SMS, WhatsApp ve link paylaşımı ile tekliflerinizi ve siparişlerinizi müşterilerinize ulaştırın.",
      email: "E-Posta",
      sms: "SMS",
      whatsapp: "WhatsApp",
      link: "Link Paylaşımı",
    },
    integrations: {
      overline: "ENTEGRASYONLAR",
      title: "Güçlü Entegrasyonlar",
      urge: "UR-GE ERP Entegrasyonu",
      whatsapp: "WhatsApp Entegrasyonu",
      smtp: "Kendi SMTP Mailiniz",
      api: "API Erişimi",
      accounting: "Ön Muhasebe",
      communication: "Haberleşme Sistemi",
      quoteRequest: "Teklif Talebi Sistemi",
      afterSales: "Satış Sonrası Hizmet",
      brandless: "Markasız Kullanım",
      b2bCrm: "B2B CRM",
    },
    pricing: {
      overline: "FİYATLANDIRMA",
      title: "Paketler ve Fiyatlandırma",
      subtitle: "İş yönetiminin devrim yaratan platformuyla en uygun fiyatlara hazır mısınız?",
      yearly: "Yıllık",
      free: "Ücretsiz Paket",
      starter: "Başlangıç Paketi",
      pro: "Pro Paket",
      business: "Business Paket",
      popular: "Popüler",
      features: {
        multiCurrency: "TL, USD, EUR, GBP Teklif oluşturma",
        messaging: "WhatsApp, SMS ve e-posta ile Teklif Gönderme",
        orderMgmt: "Sipariş Yönetimi",
        priceList: "Fiyat Listesi Yönetimi",
        dealerPortal: "Bayi Portalı ile Müşterilerden Sipariş Alma",
        unlimitedUsers: "Sınırsız Kullanıcı",
      },
      limits: {
        products: "Ürün Ekleme",
        branches: "Şube Yönetimi",
        dealers: "Bayi Yönetimi",
        suppliers: "Entegre Tedarikçi",
      },
      addons: {
        title: "Ek Modüller",
        api: "API Sistemi",
        accounting: "Ön Muhasebe",
        quoteRequest: "Teklif Talebi",
        payment: "Ödeme Sistemi",
        communication: "Haberleşme Sistemi",
        soon: "Yakında",
      },
      cta: "Ücretsiz Kullan",
      ctaStarter: "Hemen Başla",
    },
    faq: {
      overline: "SIKÇA SORULAN SORULAR",
      title: "Merak Ettikleriniz",
      description: "EntegrePanel hakkında en çok merak edilen soruları sizin için derledik.",
      questionsLabel: "Soru",
      supportLabel: "Destek",
      ctaTitle: "Aradığınızı bulamadınız mı?",
      ctaSubtitle: "Destek ekibimize ulaşın, size yardımcı olalım.",
      items: [
        {
          q: "Entegrepanel tam olarak nedir?",
          a: "Entegrepanel, iş süreçlerinizi merkezi ve entegre bir platform üzerinden yönetmenizi sağlayan bir iş yönetimi uygulamasıdır. Ürün, fiyat, teklif, proforma ve ön muhasebe yönetimi gibi birçok işlevi bir araya getirir."
        },
        {
          q: "Tekliflerimi müşterilere nasıl iletebilirim?",
          a: "Entegrepanel ile hazırladığınız teklifleri SMS, e-posta veya WhatsApp gibi kanallar üzerinden doğrudan müşterilere iletebilirsiniz."
        },
        {
          q: "Hangi platformlarda kullanabilirim?",
          a: "Entegrepanel web tabanlı bir platformdur, bu nedenle internete bağlı herhangi bir cihazdan (bilgisayar, tablet, akıllı telefon) erişebilirsiniz."
        },
        {
          q: "Ön muhasebe işlemlerini yönetebilir miyim?",
          a: "Evet. Faturalar, banka işlemleri, masraflar, stok kayıtları gibi temel ön muhasebe süreçlerini kolayca yönetebilirsiniz."
        },
        {
          q: "Ürün stok takibi yapabilir miyim?",
          a: "Evet, ürün stok takibinizi kolaylıkla gerçekleştirebilir ve stok durumu hakkında anlık bilgilere erişebilirsiniz."
        },
        {
          q: "Ücretsiz sürümü nasıl kullanabilirim?",
          a: "Entegrepanel'in resmi web sitesi üzerinden ücretsiz kayıt olabilir ve ücretsiz sürümüne erişim sağlayabilirsiniz. Ücretsiz sürümünü ömür boyu kullanabilirsiniz."
        },
        {
          q: "Verilerim güvende mi?",
          a: "Evet, tüm verileriniz SSL sertifikası ile korunmakta ve düzenli yedeklemeler ile herhangi bir veri kaybını önlenmektedir. Gelişmiş güvenlik protokolleri ve şifreleme yöntemleri kullanılmaktadır."
        },
      ],
    },
    contact: {
      overline: "İLETİŞİM",
      title: "Bizimle İletişime Geçin",
      subtitle: "Sorularınız için bize ulaşın veya ücretsiz demo randevusu alın.",
      name: "Adınız Soyadınız",
      email: "E-posta Adresiniz",
      phone: "Telefon Numaranız",
      message: "Mesajınız",
      send: "Mesaj Gönder",
      success: "Talebiniz başarıyla alındı! En kısa sürede size dönüş yapacağız.",
      sendAnother: "Yeni mesaj gönder",
      company: "Hobala E-Ticaret Reklam Ve Aracılık LTD ŞTİ",
      tabContact: "Mesaj Gönder",
      tabDemo: "Demo Sunumu İste",
      companyPlaceholder: "Firma adınız",
      companyLabel: "Firma Adı",
      selectDate: "Tarih Seçin",
      selectTime: "Saat Seçin",
      demoNote: "Notunuz (Opsiyonel)",
      demoNotePlaceholder: "Hangi özelliklerle ilgileniyorsunuz?",
      requestDemo: "Demo Randevusu Al",
    },
    howItWorks: {
      overline: "NASIL ÇALIŞIR",
      title: "4 Adımda İş Sürecinizi Dijitalleştirin",
      subtitle: "Teklif oluşturmadan sipariş takibine, tüm süreçleriniz dijital ve otomatik.",
      createQuote: "Teklif Oluşturun",
      createQuoteDesc: "TL, USD, EUR veya GBP ile profesyonel teklifler hazırlayın. Fiyat listenizi seçin, ürünleri ekleyin, belge şablonunuzu kullanın.",
      sendQuote: "Müşteriye Gönderin",
      sendQuoteDesc: "Hazırladığınız teklifi SMS, WhatsApp, e-posta veya link ile müşterinize anında gönderin. Görüntülenme takibi yapın.",
      getOrder: "Siparişe Dönüştürün",
      getOrderDesc: "Onaylanan teklifleri tek tıkla siparişe çevirin. Fabrika üretim sürecinizi başlatın, termin tarihi belirleyin.",
      trackAnalyze: "Takip Edin & Analiz Edin",
      trackAnalyzeDesc: "Cironuzu, dönüşüm oranlarınızı ve bayi performansını detaylı grafiklerle takip edin. Veri odaklı kararlar alın.",
    },
    capabilities: {
      overline: "TEMEL YETENEKLER",
      title: "İşletmenizi Güçlendiren Özellikler",
      multiCurrency: "Çoklu Döviz Desteği",
      multiCurrencyDesc: "TL, USD, EUR ve GBP ile fiyat listeleri oluşturun. Her para birimi için ayrı stok satış fiyatları tanımlayın.",
      communication: "Çoklu İletişim Kanalı",
      communicationDesc: "Tekliflerinizi SMS, WhatsApp, e-posta ve link paylaşımı ile gönderin. Müşterinizin teklifi görüntülediğini takip edin.",
      afterSales: "Satış Sonrası Hizmet (SSH)",
      afterSalesDesc: "Müşteri şikayetlerini ve hata kayıtlarını takip edin. SSH sürecinizi dijitalleştirin, hata sebeplerini analiz edin.",
      contracts: "Bağlantı Sözleşmeleri",
      contractsDesc: "Bayileriniz ile bağlantı sözleşmelerini dijital ortamda yönetin. Sözleşme süreleri ve koşullarını takip edin.",
    },
    ecosystem: {
      overline: "ENTEGRE EKOSİSTEM",
      title: "Tüm İş Süreçleriniz Tek Merkezde",
      subtitle: "Tedarikçilerden bayilere, şubelerden müşterilere kadar tüm iş akışınızı tek panelden yönetin. Her adımı görün, kontrol edin, optimize edin.",
      suppliers: "Tedarikçiler",
      supplier: "Tedarikçi",
      dealer: "Bayi",
      dealersBranches: "Bayiler & Şubeler",
      customers: "Müşteriler",
      panelTitle: "EntegrePanel",
      panelDesc: "Merkezi yönetim platformu",
      getQuote: "Ürün & Teklif Al",
      orderQuote: "Sipariş Teklifi",
      dataSync: "Veri Senkron",
      sendQuote: "Teklif Gönder",
      quote: "Teklif",
      order: "Sipariş",
      crm: "CRM",
      quoteFlow: "Teklif Süreci",
      quoteFlowDesc: "Müşterilerinize profesyonel teklifler hazırlayın, SMS/WhatsApp/E-posta ile anında gönderin. Teklif görüntülenme takibi yapın.",
      quoteFlowPoints: ["TL, USD, EUR, GBP ile çoklu döviz teklifi", "SMS, WhatsApp, E-posta ile gönderim", "Teklif görüntülenme ve onay takibi", "Tek tıkla siparişe dönüştürme"],
      orderFlow: "Sipariş Yönetimi",
      orderFlowDesc: "Onaylanan teklifleri siparişe dönüştürün, üretim sürecini takip edin, termin tarihlerini yönetin.",
      orderFlowPoints: ["Tekliften siparişe otomatik dönüşüm", "Ödeme durumu ve kalan bakiye takibi", "Termin tarihi ve üretim süreci", "Detaylı sipariş raporları"],
      dealerFlow: "Bayi Performansı",
      dealerFlowDesc: "Bayilerinizin teklif ve sipariş performansını takip edin. Bağlantı sözleşmelerini yönetin.",
      dealerFlowPoints: ["Bayi bazlı teklif/sipariş istatistikleri", "Dönüşüm oranları ve ciro analizi", "Bağlantı sözleşme yönetimi", "Bayilere toplu teklif gönderimi"],
      supplierFlow: "Tedarikçi Entegrasyonu",
      supplierFlowDesc: "Entegre tedarikçilerden ürün ve fiyat bilgisi alın, doğrudan sipariş verin.",
      supplierFlowPoints: ["Tedarikçi ürün kataloğuna erişim", "Otomatik fiyat senkronizasyonu", "Doğrudan sipariş oluşturma", "Sipariş durumu takibi"],
      crmFlow: "B2B CRM",
      crmFlowDesc: "Saha satış ekibinizi yönetin, müşteri ziyaretlerini planlayın, pipeline ile fırsatları takip edin.",
      crmFlowPoints: ["Saha ekibi ziyaret takvimi", "Müşteri haritası ve rota planlama", "Satış pipeline yönetimi", "Ziyaret ve performans raporları"],
    },
    multidevice: {
      overline: "HER YERDEN ERİŞİM",
      title: "Cebinizden, Tabletinizden veya Bilgisayarınızdan Yönetin",
      subtitle: "EntegrePanel tamamen responsive tasarımı ile her cihazda kusursuz çalışır. Sahada mobil, ofiste masaüstü kullanın.",
      phone: "Akıllı Telefon",
      tablet: "Tablet",
      computer: "Bilgisayar",
    },
    furniture: {
      overline: "MOBİLYA SEKTÖRÜ",
      title: "Mobilya Sektörüne Özel B2B Çözüm",
      subtitle: "İnegöl mobilya sektöründen doğan, sektörün ihtiyaçlarını bilen bir platform. Koltuk takımından yatak odasına, sehpadan gardıroba tüm ürünlerinizi kolayca yönetin.",
      catalog: "Ürün Kataloğu",
      catalogDesc: "Mobilya ürünlerinizi görselleri ile birlikte kataloglayın.",
      dealers: "Bayi Ağı",
      dealersDesc: "Türkiye genelinde bayi ağınızı tek panelden yönetin.",
      pricing: "Dinamik Fiyatlandırma",
      pricingDesc: "TL, USD, EUR ile farklı fiyat listeleri oluşturun.",
      field: "Saha Satış",
      fieldDesc: "CRM ile saha ekibinizin ziyaretlerini takip edin.",
      crm: "Müşteri Takibi",
      crmDesc: "Müşteri haritası ve pipeline ile satışları optimize edin.",
      b2b: "B2B Portal",
      b2bDesc: "Bayilerinize özel sipariş portalı sunun.",
      quoteStat: "Teklif Oluşturuldu",
      orderStat: "Sipariş Tamamlandı",
      catalogTitle: "Gerçek Ürün Kataloğu",
      catalogSubtitle: "Sehpadan gardroba, masadan koltuğa tüm ürünlerinizi görselleriyle birlikte yönetin",
      priceListTitle: "Çoklu Döviz Fiyat Listeleri",
      priceListSubtitle: "TRY, USD, EUR ve GBP ile farklı fiyat listeleri oluşturun ve yönetin",
    },
    footer: {
      description: "Tekliften muhasebeye, proforma'dan siparişe komple çözüm. UR-GE Yazılım tarafından geliştirilmiştir.",
      quickLinks: "Hızlı Bağlantılar",
      legal: "Yasal",
      privacy: "Gizlilik Politikası",
      terms: "Kullanım Koşulları",
      rights: "Tüm hakları saklıdır.",
    },
    imageAlt: {
      logo: "EntegrePanel Logo - B2B Bayi Yönetim Sistemi",
      heroDashboard: "EntegrePanel B2B Bayi Yönetim Sistemi - Dashboard Ekranı: Teklif, Sipariş ve Bayi Takibi",
      quoteManagement: "EntegrePanel Teklif Yönetimi Ekranı - Çoklu Döviz Teklif Oluşturma",
      orderManagement: "EntegrePanel Sipariş Yönetimi - Fabrika Sipariş Takibi",
      dealerNetwork: "EntegrePanel Bayi Ağı Yönetimi - B2B Bayi Portalı",
      supplierIntegration: "EntegrePanel Entegre Tedarikçi Sistemi - Ürün ve Fiyat Senkronizasyonu",
      preAccounting: "EntegrePanel Ön Muhasebe Yazılımı - Gelir Gider Takibi",
      analytics: "EntegrePanel Detaylı Analiz ve Raporlama Dashboard",
      crmDashboard: "EntegrePanel B2B CRM Dashboard - Saha Satış Yönetimi",
      furnitureShowroom: "Mobilya Sektörü B2B Çözümü - Showroom ve Bayi Yönetimi",
      furnitureCatalog: "Mobilya Ürün Kataloğu - Görsel Bazlı Ürün Yönetimi",
      furnitureDealer: "Mobilya Bayi Ağı - B2B Toptan Satış",
      productManagement: "Mobilya Ürün Yönetim Paneli",
      multiCurrency: "Çoklu Döviz Fiyat Listesi - TL, USD, EUR, GBP",
      mobileQuote: "Mobilden Teklif Oluşturma - EntegrePanel iOS ve Android",
      mobileDashboard: "Mobil Dashboard - EntegrePanel Mobil B2B Yönetim",
      mobileCatalog: "Mobil Ürün Kataloğu - EntegrePanel Mobil",
    },
    blog: {
      overline: "ENTEGREPANEL BLOG",
      heroTitle: "B2B Dünyasından Haberler & İpuçları",
      heroSubtitle: "Sektörden gelişmeler, ürün güncellemeleri ve B2B bayi yönetimi üzerine ipuçları.",
      searchPlaceholder: "Yazılarda ara…",
      searchButton: "Ara",
      featured: "Öne Çıkan Yazılar",
      allPosts: "Tümü",
      categories: "Kategoriler",
      categoryResults: "Kategori",
      categorySubtitle: "Bu kategorideki tüm yazılar",
      tags: "Etiketler",
      tagSubtitle: "Bu etiketle işaretlenmiş yazılar",
      popular: "Popüler",
      searchResults: "Arama Sonuçları",
      postsCount: "yazı",
      empty: "Henüz bu kriterlere uygun yazı yok.",
      loadError: "Yazılar yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin.",
      notFound: "Yazı Bulunamadı",
      notFoundDesc: "Aradığınız yazı kaldırılmış veya taşınmış olabilir. Blog ana sayfasına yönlendiriliyorsunuz…",
      backToBlog: "Blog'a Dön",
      related: "İlgili Yazılar",
      share: "Paylaş",
      copyLink: "Bağlantıyı kopyala",
      copied: "Kopyalandı",
      toc: "İçindekiler",
    },
  },
  en: {
    nav: {
      features: "Features",
      pricing: "Pricing",
      faq: "FAQ",
      contact: "Contact",
      blog: "Blog",
      demoLogin: "Panel Login",
      register: "Get Started",
    },
    hero: {
      overline: "B2B DEALER MANAGEMENT SYSTEM",
      title: "From Quotes to Orders,",
      titleHighlight: "All in One Panel.",
      subtitle: "B2B dealer management software to create quotes, track orders, manage your dealer network. Reach customers via SMS, WhatsApp and email. Integrated supplier system and pre-accounting included.",
      cta: "Start Free",
      ctaSecondary: "View Demo",
      conversionRate: "Quote → Order",
    },
    stats: {
      dealers: "Active Dealers",
      orders: "Monthly Orders",
      quotes: "Quotes Sent",
      satisfaction: "Customer Satisfaction",
    },
    features: {
      overline: "FEATURES",
      title: "Manage Your B2B Processes From a Single Panel",
      subtitle: "Quote management, order tracking, dealer portal, integrated supplier system and pre-accounting software. All your business processes on one platform.",
      quoteManagement: "Quote Management",
      quoteDesc: "Create professional quotes in TRY, USD, EUR, GBP. Send instantly via SMS, WhatsApp and email. Track quote views and approvals.",
      orderManagement: "Order Management",
      orderDesc: "Manage factory orders from a central point. Convert approved quotes to orders with one click. Track delivery dates and payments.",
      dealerManagement: "Dealer & Branch Management",
      dealerDesc: "Manage your dealer network and branches from one panel. Dealer performance tracking, connection contracts and bulk quote sending.",
      supplierIntegration: "Integrated Supplier System",
      supplierDesc: "Get product and pricing from integrated suppliers, place orders directly. Automatic price synchronization.",
      preAccounting: "Pre-Accounting Software",
      preAccountingDesc: "Sales/purchase invoices, bank transactions, expense tracking and stock management. Financial reports for full control.",
      analytics: "Detailed Analytics & Reports",
      analyticsDesc: "Analyze revenue, order trends, dealer performance and conversion rates with detailed charts. Make data-driven decisions.",
    },
    crm: {
      overline: "B2B CRM",
      title: "Strong in the Field, Smart at the Desk",
      subtitle: "Optimize your sales process with visit planning, pipeline management, customer map and detailed reports.",
      visits: "Visit Calendar",
      visitsDesc: "Plan and track your field team's visits.",
      pipeline: "Sales Pipeline",
      pipelineDesc: "Manage your opportunities through interested, qualified, offer and negotiation stages.",
      map: "Customer Map",
      mapDesc: "View your customers on the map and plan routes.",
      reports: "CRM Reports",
      reportsDesc: "Analyze your visit, quote and order trends.",
    },
    communication: {
      overline: "COMMUNICATION CHANNELS",
      title: "Send Your Quotes Instantly",
      subtitle: "Deliver your quotes and orders to your customers via email, SMS, WhatsApp and link sharing.",
      email: "Email",
      sms: "SMS",
      whatsapp: "WhatsApp",
      link: "Link Sharing",
    },
    integrations: {
      overline: "INTEGRATIONS",
      title: "Powerful Integrations",
      urge: "UR-GE ERP Integration",
      whatsapp: "WhatsApp Integration",
      smtp: "Custom SMTP Email",
      api: "API Access",
      accounting: "Pre-Accounting",
      communication: "Communication System",
      quoteRequest: "Quote Request System",
      afterSales: "After-Sales Service",
      brandless: "White Label Usage",
      b2bCrm: "B2B CRM",
    },
    pricing: {
      overline: "PRICING",
      title: "Packages and Pricing",
      subtitle: "Are you ready for the most affordable prices with the revolutionary platform of business management?",
      yearly: "Yearly",
      free: "Free Plan",
      starter: "Starter Plan",
      pro: "Pro Plan",
      business: "Business Plan",
      popular: "Popular",
      features: {
        multiCurrency: "Create quotes in TRY, USD, EUR, GBP",
        messaging: "Send quotes via WhatsApp, SMS and email",
        orderMgmt: "Order Management",
        priceList: "Price List Management",
        dealerPortal: "Accept orders from customers via Dealer Portal",
        unlimitedUsers: "Unlimited Users",
      },
      limits: {
        products: "Product Upload",
        branches: "Branch Management",
        dealers: "Dealer Management",
        suppliers: "Integrated Supplier",
      },
      addons: {
        title: "Add-on Modules",
        api: "API System",
        accounting: "Pre-Accounting",
        quoteRequest: "Quote Request",
        payment: "Payment System",
        communication: "Communication System",
        soon: "Coming Soon",
      },
      cta: "Use Free",
      ctaStarter: "Get Started",
    },
    faq: {
      overline: "FREQUENTLY ASKED QUESTIONS",
      title: "Common Questions",
      description: "We've compiled the most frequently asked questions about EntegrePanel for you.",
      questionsLabel: "Questions",
      supportLabel: "Support",
      ctaTitle: "Can't find what you're looking for?",
      ctaSubtitle: "Contact our support team, we'll be happy to help.",
      items: [
        {
          q: "What exactly is Entegrepanel?",
          a: "Entegrepanel is a business management application that allows you to manage your business processes on a centralized and integrated platform. It combines many functions such as product, price, quote, proforma and pre-accounting management."
        },
        {
          q: "How can I send quotes to customers?",
          a: "You can send the quotes you prepared with Entegrepanel directly to customers through channels such as SMS, email or WhatsApp."
        },
        {
          q: "Which platforms can I use it on?",
          a: "Entegrepanel is a web-based platform, so you can access it from any internet-connected device (computer, tablet, smartphone)."
        },
        {
          q: "Can I manage pre-accounting?",
          a: "Yes. You can easily manage basic pre-accounting processes such as invoices, bank transactions, expenses, and stock records."
        },
        {
          q: "Can I track product stock?",
          a: "Yes, you can easily track your product stock and access real-time information about stock status."
        },
        {
          q: "How can I use the free version?",
          a: "You can register for free through Entegrepanel's official website and access the free version. You can use the free version for a lifetime."
        },
        {
          q: "Is my data safe?",
          a: "Yes, all your data is protected with SSL certificate and regular backups prevent any data loss. Advanced security protocols and encryption methods are used."
        },
      ],
    },
    contact: {
      overline: "CONTACT",
      title: "Get in Touch",
      subtitle: "Reach out with your questions or schedule a free demo appointment.",
      name: "Your Full Name",
      email: "Your Email Address",
      phone: "Your Phone Number",
      message: "Your Message",
      send: "Send Message",
      success: "Your request has been received! We will get back to you shortly.",
      sendAnother: "Send another message",
      company: "Hobala E-Commerce Advertising and Mediation LLC",
      tabContact: "Send Message",
      tabDemo: "Request Demo",
      companyPlaceholder: "Your company name",
      companyLabel: "Company Name",
      selectDate: "Select Date",
      selectTime: "Select Time",
      demoNote: "Your Note (Optional)",
      demoNotePlaceholder: "Which features are you interested in?",
      requestDemo: "Book Demo Appointment",
    },
    howItWorks: {
      overline: "HOW IT WORKS",
      title: "Digitize Your Business in 4 Steps",
      subtitle: "From creating quotes to order tracking, all your processes are digital and automated.",
      createQuote: "Create a Quote",
      createQuoteDesc: "Prepare professional quotes in TRY, USD, EUR or GBP. Select your price list, add products, use your document template.",
      sendQuote: "Send to Customer",
      sendQuoteDesc: "Send your prepared quote instantly via SMS, WhatsApp, email or link. Track when it's viewed.",
      getOrder: "Convert to Order",
      getOrderDesc: "Convert approved quotes to orders with one click. Start your factory production process, set delivery dates.",
      trackAnalyze: "Track & Analyze",
      trackAnalyzeDesc: "Track your revenue, conversion rates and dealer performance with detailed charts. Make data-driven decisions.",
    },
    capabilities: {
      overline: "KEY CAPABILITIES",
      title: "Features That Empower Your Business",
      multiCurrency: "Multi-Currency Support",
      multiCurrencyDesc: "Create price lists in TRY, USD, EUR and GBP. Define separate stock sale prices for each currency.",
      communication: "Multi-Channel Communication",
      communicationDesc: "Send your quotes via SMS, WhatsApp, email and link sharing. Track when your customer views the quote.",
      afterSales: "After-Sales Service (SSH)",
      afterSalesDesc: "Track customer complaints and error records. Digitize your after-sales process, analyze error causes.",
      contracts: "Dealer Contracts",
      contractsDesc: "Manage dealer connection contracts digitally. Track contract durations and conditions.",
    },
    ecosystem: {
      overline: "INTEGRATED ECOSYSTEM",
      title: "All Your Business Processes in One Center",
      subtitle: "Manage your entire workflow from suppliers to dealers, branches to customers. See every step, control and optimize.",
      suppliers: "Suppliers",
      supplier: "Supplier",
      dealer: "Dealer",
      dealersBranches: "Dealers & Branches",
      customers: "Customers",
      panelTitle: "EntegrePanel",
      panelDesc: "Central management platform",
      getQuote: "Get Product & Quote",
      orderQuote: "Order Quote",
      dataSync: "Data Sync",
      sendQuote: "Send Quote",
      quote: "Quote",
      order: "Order",
      crm: "CRM",
      quoteFlow: "Quote Process",
      quoteFlowDesc: "Prepare professional quotes for your customers, send instantly via SMS/WhatsApp/Email. Track quote views.",
      quoteFlowPoints: ["Multi-currency quotes in TRY, USD, EUR, GBP", "Send via SMS, WhatsApp, Email", "Quote view and approval tracking", "One-click convert to order"],
      orderFlow: "Order Management",
      orderFlowDesc: "Convert approved quotes to orders, track production process, manage delivery dates.",
      orderFlowPoints: ["Automatic quote-to-order conversion", "Payment status and balance tracking", "Delivery dates and production process", "Detailed order reports"],
      dealerFlow: "Dealer Performance",
      dealerFlowDesc: "Track your dealers' quote and order performance. Manage connection contracts.",
      dealerFlowPoints: ["Dealer-based quote/order statistics", "Conversion rates and revenue analysis", "Contract management", "Bulk quote sending to dealers"],
      supplierFlow: "Supplier Integration",
      supplierFlowDesc: "Get product and price info from integrated suppliers, place orders directly.",
      supplierFlowPoints: ["Access supplier product catalog", "Automatic price synchronization", "Direct order creation", "Order status tracking"],
      crmFlow: "B2B CRM",
      crmFlowDesc: "Manage your field sales team, plan customer visits, track opportunities with pipeline.",
      crmFlowPoints: ["Field team visit calendar", "Customer map and route planning", "Sales pipeline management", "Visit and performance reports"],
    },
    multidevice: {
      overline: "ACCESS ANYWHERE",
      title: "Manage from Your Phone, Tablet or Computer",
      subtitle: "EntegrePanel works flawlessly on every device with its fully responsive design. Use mobile in the field, desktop in the office.",
      phone: "Smartphone",
      tablet: "Tablet",
      computer: "Computer",
    },
    furniture: {
      overline: "FURNITURE INDUSTRY",
      title: "B2B Solution for the Furniture Sector",
      subtitle: "A platform born from the Inegol furniture industry, understanding the sector's needs. Easily manage all your products from sofa sets to bedrooms, coffee tables to wardrobes.",
      catalog: "Product Catalog",
      catalogDesc: "Catalog your furniture products with images.",
      dealers: "Dealer Network",
      dealersDesc: "Manage your dealer network across Turkey from a single panel.",
      pricing: "Dynamic Pricing",
      pricingDesc: "Create different price lists in TRY, USD, EUR.",
      field: "Field Sales",
      fieldDesc: "Track your field team's visits with CRM.",
      crm: "Customer Tracking",
      crmDesc: "Optimize sales with customer map and pipeline.",
      b2b: "B2B Portal",
      b2bDesc: "Offer a dedicated order portal for your dealers.",
      quoteStat: "Quotes Created",
      orderStat: "Orders Completed",
      catalogTitle: "Real Product Catalog",
      catalogSubtitle: "Manage all your products from coffee tables to wardrobes with images",
      priceListTitle: "Multi-Currency Price Lists",
      priceListSubtitle: "Create and manage price lists in TRY, USD, EUR and GBP",
    },
    footer: {
      description: "Complete solution from quotes to accounting, from proforma to orders. Developed by UR-GE Yazılım.",
      quickLinks: "Quick Links",
      legal: "Legal",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      rights: "All rights reserved.",
    },
    imageAlt: {
      logo: "EntegrePanel Logo - B2B Dealer Management System",
      heroDashboard: "EntegrePanel B2B Dealer Management - Dashboard: Quotes, Orders and Dealer Tracking",
      quoteManagement: "EntegrePanel Quote Management Screen - Multi-Currency Quote Creation",
      orderManagement: "EntegrePanel Order Management - Factory Order Tracking",
      dealerNetwork: "EntegrePanel Dealer Network Management - B2B Dealer Portal",
      supplierIntegration: "EntegrePanel Integrated Supplier System - Product and Price Sync",
      preAccounting: "EntegrePanel Pre-Accounting Software - Income Expense Tracking",
      analytics: "EntegrePanel Detailed Analytics and Reporting Dashboard",
      crmDashboard: "EntegrePanel B2B CRM Dashboard - Field Sales Management",
      furnitureShowroom: "Furniture Industry B2B Solution - Showroom and Dealer Management",
      furnitureCatalog: "Furniture Product Catalog - Visual Product Management",
      furnitureDealer: "Furniture Dealer Network - B2B Wholesale",
      productManagement: "Furniture Product Management Panel",
      multiCurrency: "Multi-Currency Price Lists - TRY, USD, EUR, GBP",
      mobileQuote: "Mobile Quote Creation - EntegrePanel iOS and Android",
      mobileDashboard: "Mobile Dashboard - EntegrePanel Mobile B2B Management",
      mobileCatalog: "Mobile Product Catalog - EntegrePanel Mobile",
    },
    blog: {
      overline: "ENTEGREPANEL BLOG",
      heroTitle: "News & Tips from the B2B World",
      heroSubtitle: "Industry insights, product updates and tips on B2B dealer management.",
      searchPlaceholder: "Search articles…",
      searchButton: "Search",
      featured: "Featured Articles",
      allPosts: "All",
      categories: "Categories",
      categoryResults: "Category",
      categorySubtitle: "All articles in this category",
      tags: "Tags",
      tagSubtitle: "Articles tagged with this keyword",
      popular: "Popular",
      searchResults: "Search Results",
      postsCount: "articles",
      empty: "No articles match these criteria yet.",
      loadError: "An error occurred while loading articles. Please refresh the page.",
      notFound: "Article Not Found",
      notFoundDesc: "The article you're looking for may have been removed or moved. Redirecting to the blog…",
      backToBlog: "Back to Blog",
      related: "Related Articles",
      share: "Share",
      copyLink: "Copy link",
      copied: "Copied",
      toc: "Table of Contents",
    },
  },
  ar: {
    nav: {
      features: "الميزات",
      pricing: "الأسعار",
      faq: "الأسئلة",
      contact: "اتصل بنا",
      blog: "المدونة",
      demoLogin: "دخول اللوحة",
      register: "كن عميلاً",
    },
    hero: {
      overline: "نظام إدارة الوكلاء B2B",
      title: "من العروض إلى الطلبات،",
      titleHighlight: "الكل في لوحة واحدة.",
      subtitle: "برنامج إدارة الوكلاء B2B لإنشاء عروض الأسعار، تتبع الطلبات، إدارة شبكة الوكلاء. تواصل مع عملائك فوراً عبر الرسائل القصيرة وواتساب والبريد الإلكتروني. نظام موردين متكامل ومحاسبة أولية.",
      cta: "ابدأ مجاناً",
      ctaSecondary: "عرض تجريبي",
      conversionRate: "عرض → طلب",
    },
    stats: {
      dealers: "وكيل نشط",
      orders: "طلب شهري",
      quotes: "عرض أسعار مرسل",
      satisfaction: "رضا العملاء",
    },
    features: {
      overline: "الميزات",
      title: "أدر عمليات B2B من لوحة واحدة",
      subtitle: "إدارة العروض، تتبع الطلبات، بوابة الوكلاء، نظام موردين متكامل وبرنامج محاسبة أولية. جميع عملياتك في منصة واحدة.",
      quoteManagement: "إدارة العروض",
      quoteDesc: "أنشئ عروض أسعار احترافية بالليرة والدولار واليورو والجنيه. أرسل فوراً عبر الرسائل القصيرة وواتساب والبريد. تتبع المشاهدات والموافقات.",
      orderManagement: "إدارة الطلبات",
      orderDesc: "أدر طلبات المصنع من نقطة مركزية. حوّل العروض المعتمدة إلى طلبات بنقرة واحدة. تتبع مواعيد التسليم والمدفوعات.",
      dealerManagement: "إدارة الوكلاء والفروع",
      dealerDesc: "أدر شبكة وكلائك وفروعك من لوحة واحدة. تتبع أداء الوكلاء، عقود الاتصال وإرسال عروض جماعية.",
      supplierIntegration: "نظام موردين متكامل",
      supplierDesc: "احصل على معلومات المنتجات والأسعار من الموردين المتكاملين، اطلب مباشرة. مزامنة أسعار تلقائية.",
      preAccounting: "برنامج المحاسبة الأولية",
      preAccountingDesc: "فواتير البيع/الشراء، المعاملات المصرفية، تتبع المصروفات وإدارة المخزون. تقارير مالية للسيطرة الكاملة.",
      analytics: "تحليلات وتقارير مفصلة",
      analyticsDesc: "حلل الإيرادات واتجاهات الطلبات وأداء الوكلاء ومعدلات التحويل بالرسوم البيانية المفصلة.",
    },
    crm: {
      overline: "B2B CRM",
      title: "قوي في الميدان، ذكي في المكتب",
      subtitle: "حسّن عملية مبيعاتك مع تخطيط الزيارات وإدارة خط الأنابيب وخريطة العملاء والتقارير المفصلة.",
      visits: "تقويم الزيارات",
      visitsDesc: "خطط وتابع زيارات فريقك الميداني.",
      pipeline: "خط أنابيب المبيعات",
      pipelineDesc: "أدر فرصك عبر مراحل الاهتمام والتأهيل والعرض والتفاوض.",
      map: "خريطة العملاء",
      mapDesc: "اعرض عملاءك على الخريطة وخطط للمسارات.",
      reports: "تقارير CRM",
      reportsDesc: "حلل اتجاهات الزيارات والعروض والطلبات.",
    },
    communication: {
      overline: "قنوات الاتصال",
      title: "أرسل عروضك فوراً",
      subtitle: "أوصل عروضك وطلباتك لعملائك عبر البريد الإلكتروني والرسائل القصيرة وواتساب ومشاركة الروابط.",
      email: "البريد الإلكتروني",
      sms: "رسائل قصيرة",
      whatsapp: "واتساب",
      link: "مشاركة الرابط",
    },
    integrations: {
      overline: "التكاملات",
      title: "تكاملات قوية",
      urge: "تكامل UR-GE ERP",
      whatsapp: "تكامل واتساب",
      smtp: "بريد SMTP مخصص",
      api: "وصول API",
      accounting: "المحاسبة الأولية",
      communication: "نظام الاتصالات",
      quoteRequest: "نظام طلب العروض",
      afterSales: "خدمة ما بعد البيع",
      brandless: "استخدام بدون علامة تجارية",
      b2bCrm: "B2B CRM",
    },
    pricing: {
      overline: "الأسعار",
      title: "الباقات والأسعار",
      subtitle: "هل أنت مستعد لأفضل الأسعار مع المنصة الثورية لإدارة الأعمال؟",
      yearly: "سنوي",
      free: "الباقة المجانية",
      starter: "باقة البداية",
      pro: "الباقة الاحترافية",
      business: "باقة الأعمال",
      popular: "الأكثر شعبية",
      features: {
        multiCurrency: "إنشاء عروض بالليرة والدولار واليورو والجنيه",
        messaging: "إرسال العروض عبر واتساب والرسائل القصيرة والبريد",
        orderMgmt: "إدارة الطلبات",
        priceList: "إدارة قوائم الأسعار",
        dealerPortal: "قبول الطلبات من العملاء عبر بوابة الوكلاء",
        unlimitedUsers: "مستخدمون غير محدودون",
      },
      limits: {
        products: "إضافة منتج",
        branches: "إدارة الفروع",
        dealers: "إدارة الوكلاء",
        suppliers: "مورد متكامل",
      },
      addons: {
        title: "وحدات إضافية",
        api: "نظام API",
        accounting: "المحاسبة الأولية",
        quoteRequest: "طلب العروض",
        payment: "نظام الدفع",
        communication: "نظام الاتصالات",
        soon: "قريباً",
      },
      cta: "استخدم مجاناً",
      ctaStarter: "ابدأ الآن",
    },
    faq: {
      overline: "الأسئلة الشائعة",
      title: "أسئلة شائعة",
      description: "جمعنا لك الأسئلة الأكثر شيوعاً حول EntegrePanel.",
      questionsLabel: "سؤال",
      supportLabel: "دعم",
      ctaTitle: "لم تجد ما تبحث عنه؟",
      ctaSubtitle: "تواصل مع فريق الدعم، سنكون سعداء بمساعدتك.",
      items: [
        {
          q: "ما هو Entegrepanel بالضبط؟",
          a: "Entegrepanel هو تطبيق إدارة أعمال يتيح لك إدارة عمليات عملك على منصة مركزية ومتكاملة. يجمع بين العديد من الوظائف مثل إدارة المنتجات والأسعار والعروض والفواتير الأولية والمحاسبة."
        },
        {
          q: "كيف يمكنني إرسال العروض للعملاء؟",
          a: "يمكنك إرسال العروض التي أعددتها مع Entegrepanel مباشرة للعملاء عبر قنوات مثل الرسائل القصيرة أو البريد الإلكتروني أو واتساب."
        },
        {
          q: "على أي أجهزة يمكنني استخدامه؟",
          a: "Entegrepanel منصة قائمة على الويب، لذا يمكنك الوصول إليها من أي جهاز متصل بالإنترنت (كمبيوتر، جهاز لوحي، هاتف ذكي)."
        },
        {
          q: "هل يمكنني إدارة المحاسبة الأولية؟",
          a: "نعم. يمكنك إدارة عمليات المحاسبة الأولية الأساسية بسهولة مثل الفواتير والمعاملات المصرفية والمصروفات وسجلات المخزون."
        },
        {
          q: "هل يمكنني تتبع مخزون المنتجات؟",
          a: "نعم، يمكنك تتبع مخزون منتجاتك بسهولة والوصول إلى معلومات فورية حول حالة المخزون."
        },
        {
          q: "كيف يمكنني استخدام النسخة المجانية؟",
          a: "يمكنك التسجيل مجاناً عبر الموقع الرسمي لـ Entegrepanel والوصول إلى النسخة المجانية. يمكنك استخدام النسخة المجانية مدى الحياة."
        },
        {
          q: "هل بياناتي آمنة؟",
          a: "نعم، جميع بياناتك محمية بشهادة SSL والنسخ الاحتياطية المنتظمة تمنع أي فقدان للبيانات. يتم استخدام بروتوكولات أمان متقدمة وطرق تشفير."
        },
      ],
    },
    contact: {
      overline: "اتصل بنا",
      title: "تواصل معنا",
      subtitle: "تواصل معنا بأسئلتك أو احجز موعد عرض تجريبي مجاني.",
      name: "الاسم الكامل",
      email: "البريد الإلكتروني",
      phone: "رقم الهاتف",
      message: "رسالتك",
      send: "إرسال الرسالة",
      success: "تم استلام طلبك! سنعود إليك في أقرب وقت.",
      sendAnother: "إرسال رسالة أخرى",
      company: "هوبالا للتجارة الإلكترونية والإعلان والوساطة المحدودة",
      tabContact: "إرسال رسالة",
      tabDemo: "طلب عرض تجريبي",
      companyPlaceholder: "اسم شركتك",
      companyLabel: "اسم الشركة",
      selectDate: "اختر التاريخ",
      selectTime: "اختر الوقت",
      demoNote: "ملاحظتك (اختياري)",
      demoNotePlaceholder: "ما هي الميزات التي تهتم بها؟",
      requestDemo: "احجز موعد العرض",
    },
    howItWorks: {
      overline: "كيف يعمل",
      title: "رقمن عملك في 4 خطوات",
      subtitle: "من إنشاء العروض إلى تتبع الطلبات، جميع عملياتك رقمية وتلقائية.",
      createQuote: "أنشئ عرض أسعار",
      createQuoteDesc: "جهّز عروض أسعار احترافية بالليرة والدولار واليورو والجنيه. اختر قائمة أسعارك وأضف المنتجات.",
      sendQuote: "أرسل للعميل",
      sendQuoteDesc: "أرسل عرضك فوراً عبر الرسائل القصيرة أو واتساب أو البريد الإلكتروني. تتبع المشاهدات.",
      getOrder: "حوّل إلى طلب",
      getOrderDesc: "حوّل العروض المعتمدة إلى طلبات بنقرة واحدة. ابدأ عملية الإنتاج وحدد مواعيد التسليم.",
      trackAnalyze: "تابع وحلل",
      trackAnalyzeDesc: "تابع إيراداتك ومعدلات التحويل وأداء الوكلاء بالرسوم البيانية المفصلة.",
    },
    capabilities: {
      overline: "القدرات الأساسية",
      title: "ميزات تقوّي عملك",
      multiCurrency: "دعم العملات المتعددة",
      multiCurrencyDesc: "أنشئ قوائم أسعار بالليرة والدولار واليورو والجنيه. حدد أسعار مبيعات منفصلة لكل عملة.",
      communication: "قنوات اتصال متعددة",
      communicationDesc: "أرسل عروضك عبر الرسائل القصيرة وواتساب والبريد الإلكتروني. تتبع مشاهدة العميل للعرض.",
      afterSales: "خدمة ما بعد البيع",
      afterSalesDesc: "تتبع شكاوى العملاء وسجلات الأخطاء. رقمن عملية ما بعد البيع وحلل أسباب الأخطاء.",
      contracts: "عقود الوكلاء",
      contractsDesc: "أدر عقود اتصال الوكلاء رقمياً. تابع مدد العقود والشروط.",
    },
    ecosystem: {
      overline: "نظام بيئي متكامل",
      title: "جميع عمليات عملك في مركز واحد",
      subtitle: "أدر سير عملك بالكامل من الموردين إلى الوكلاء والعملاء. شاهد كل خطوة وتحكم وحسّن.",
      suppliers: "الموردون",
      supplier: "مورد",
      dealer: "وكيل",
      dealersBranches: "الوكلاء والفروع",
      customers: "العملاء",
      panelTitle: "EntegrePanel",
      panelDesc: "منصة الإدارة المركزية",
      getQuote: "احصل على منتج وعرض",
      orderQuote: "عرض طلب",
      dataSync: "مزامنة البيانات",
      sendQuote: "أرسل عرض",
      quote: "عرض",
      order: "طلب",
      crm: "CRM",
      quoteFlow: "عملية العروض",
      quoteFlowDesc: "جهّز عروض أسعار احترافية لعملائك، أرسل فوراً عبر الرسائل القصيرة/واتساب/البريد.",
      quoteFlowPoints: ["عروض متعددة العملات", "إرسال عبر قنوات متعددة", "تتبع المشاهدات والموافقات", "تحويل بنقرة واحدة إلى طلب"],
      orderFlow: "إدارة الطلبات",
      orderFlowDesc: "حوّل العروض المعتمدة إلى طلبات، تتبع عملية الإنتاج.",
      orderFlowPoints: ["تحويل تلقائي من عرض إلى طلب", "تتبع حالة الدفع", "مواعيد التسليم والإنتاج", "تقارير الطلبات المفصلة"],
      dealerFlow: "أداء الوكلاء",
      dealerFlowDesc: "تتبع أداء عروض وطلبات وكلائك. أدر عقود الاتصال.",
      dealerFlowPoints: ["إحصائيات حسب الوكيل", "معدلات التحويل والإيرادات", "إدارة العقود", "إرسال عروض جماعية"],
      supplierFlow: "تكامل الموردين",
      supplierFlowDesc: "احصل على معلومات المنتجات والأسعار من الموردين المتكاملين.",
      supplierFlowPoints: ["الوصول لكتالوج المورد", "مزامنة الأسعار تلقائياً", "إنشاء طلبات مباشرة", "تتبع حالة الطلبات"],
      crmFlow: "B2B CRM",
      crmFlowDesc: "أدر فريق المبيعات الميدانية، خطط لزيارات العملاء.",
      crmFlowPoints: ["تقويم زيارات الفريق", "خريطة العملاء والمسارات", "إدارة خط أنابيب المبيعات", "تقارير الزيارات والأداء"],
    },
    multidevice: {
      overline: "الوصول من أي مكان",
      title: "أدر من هاتفك أو جهازك اللوحي أو حاسوبك",
      subtitle: "يعمل EntegrePanel بشكل مثالي على كل جهاز بتصميمه المتجاوب بالكامل. استخدم الهاتف في الميدان والحاسوب في المكتب.",
      phone: "هاتف ذكي",
      tablet: "جهاز لوحي",
      computer: "حاسوب",
    },
    furniture: {
      overline: "صناعة الأثاث",
      title: "حل B2B لقطاع الأثاث",
      subtitle: "منصة ولدت من صناعة أثاث إينيغول، تفهم احتياجات القطاع. أدر جميع منتجاتك بسهولة من أطقم الجلوس إلى غرف النوم.",
      catalog: "كتالوج المنتجات",
      catalogDesc: "صنف منتجات الأثاث مع الصور.",
      dealers: "شبكة الوكلاء",
      dealersDesc: "أدر شبكة وكلائك عبر تركيا من لوحة واحدة.",
      pricing: "تسعير ديناميكي",
      pricingDesc: "أنشئ قوائم أسعار مختلفة بالليرة والدولار واليورو.",
      field: "مبيعات ميدانية",
      fieldDesc: "تابع زيارات فريقك الميداني مع CRM.",
      crm: "تتبع العملاء",
      crmDesc: "حسّن المبيعات بخريطة العملاء وخط الأنابيب.",
      b2b: "بوابة B2B",
      b2bDesc: "قدم بوابة طلبات مخصصة لوكلائك.",
      quoteStat: "عرض أسعار تم إنشاؤه",
      orderStat: "طلب مكتمل",
      catalogTitle: "كتالوج المنتجات الحقيقي",
      catalogSubtitle: "أدر جميع منتجاتك من الطاولات إلى الخزائن مع الصور",
      priceListTitle: "قوائم أسعار متعددة العملات",
      priceListSubtitle: "أنشئ وأدر قوائم أسعار بالليرة والدولار واليورو والجنيه",
    },
    footer: {
      description: "حل كامل من العروض إلى المحاسبة، من الفواتير الأولية إلى الطلبات. تم تطويره بواسطة UR-GE Yazılım.",
      quickLinks: "روابط سريعة",
      legal: "قانوني",
      privacy: "سياسة الخصوصية",
      terms: "شروط الخدمة",
      rights: "جميع الحقوق محفوظة.",
    },
    imageAlt: {
      logo: "شعار EntegrePanel - نظام إدارة الوكلاء B2B",
      heroDashboard: "EntegrePanel نظام إدارة الوكلاء B2B - لوحة التحكم: العروض والطلبات وتتبع الوكلاء",
      quoteManagement: "شاشة إدارة العروض في EntegrePanel - إنشاء عروض بعملات متعددة",
      orderManagement: "إدارة الطلبات في EntegrePanel - تتبع طلبات المصنع",
      dealerNetwork: "إدارة شبكة الوكلاء في EntegrePanel - بوابة الوكلاء B2B",
      supplierIntegration: "نظام الموردين المتكامل في EntegrePanel - مزامنة المنتجات والأسعار",
      preAccounting: "برنامج المحاسبة الأولية EntegrePanel - تتبع الدخل والمصروفات",
      analytics: "لوحة التحليلات والتقارير التفصيلية في EntegrePanel",
      crmDashboard: "لوحة B2B CRM في EntegrePanel - إدارة المبيعات الميدانية",
      furnitureShowroom: "حل B2B لقطاع الأثاث - إدارة صالات العرض والوكلاء",
      furnitureCatalog: "كتالوج منتجات الأثاث - إدارة المنتجات بالصور",
      furnitureDealer: "شبكة وكلاء الأثاث - البيع بالجملة B2B",
      productManagement: "لوحة إدارة منتجات الأثاث",
      multiCurrency: "قوائم أسعار متعددة العملات - الليرة، الدولار، اليورو، الجنيه",
      mobileQuote: "إنشاء عروض من الجوال - EntegrePanel iOS و Android",
      mobileDashboard: "لوحة التحكم على الجوال - إدارة B2B عبر EntegrePanel Mobile",
      mobileCatalog: "كتالوج المنتجات على الجوال - EntegrePanel Mobile",
    },
    blog: {
      overline: "مدونة ENTEGREPANEL",
      heroTitle: "أخبار ونصائح من عالم B2B",
      heroSubtitle: "آخر التحديثات الصناعية وميزات المنتج ونصائح إدارة الوكلاء B2B.",
      searchPlaceholder: "ابحث في المقالات…",
      searchButton: "بحث",
      featured: "المقالات المميزة",
      allPosts: "الكل",
      categories: "الفئات",
      categoryResults: "الفئة",
      categorySubtitle: "جميع المقالات في هذه الفئة",
      tags: "الوسوم",
      tagSubtitle: "المقالات الموسومة بهذه الكلمة",
      popular: "الأكثر شعبية",
      searchResults: "نتائج البحث",
      postsCount: "مقالة",
      empty: "لا توجد مقالات تطابق هذه المعايير حتى الآن.",
      loadError: "حدث خطأ أثناء تحميل المقالات. يرجى تحديث الصفحة.",
      notFound: "المقالة غير موجودة",
      notFoundDesc: "قد تكون المقالة التي تبحث عنها قد أُزيلت أو نُقلت. يجري توجيهك إلى المدونة…",
      backToBlog: "العودة إلى المدونة",
      related: "مقالات ذات صلة",
      share: "مشاركة",
      copyLink: "نسخ الرابط",
      copied: "تم النسخ",
      toc: "المحتويات",
    },
  },
};
